import { Redirect } from 'react-router';

import { getDidOnboarding, getStoredDocPrivacyShown, getStoredDocTermsShown } from '../helpers/device.helper';

export const InitialRoute = () => {
  const onboarded = getDidOnboarding();
  const docsDone = getStoredDocTermsShown() && getStoredDocPrivacyShown();
  return onboarded || docsDone ? <Redirect to="/ts-loading" /> : <Redirect to="/ts-onboarding" />;
};
